import React from "react";
import { CiCloudOff } from "react-icons/ci";

function NoResults({ noMarging, icon, message, subtitle, action }) {
  return (
    <div className="centered-div">
      <div className={`text-center ${noMarging ? "" : "my-5"}`}>
        {icon || <CiCloudOff size={180} className="text-muted" />}
        <h2 className="fw-bold">{message || "No data to display"}</h2>
        <p className="text-muted">{subtitle || "Please try later"}</p>
        {action && <div className="mt-3">{action}</div>}
      </div>
    </div>
  );
}

export default NoResults;
